<template>
  <div class="nav-box" id="nav-bottom">
    <div class="flex justify-center items-center">
      <div
        class="flex justify-center items-center mx-4 nav-content bg-white w-max py-4 px-7 rounded-[4rem] backdrop-blur-xl"
      >
        <nav class="flex gap-8">
          <button
            v-for="(item, index) in MENU"
            :key="index"
            class="cursor-pointer link link--elara"
            @click="scrollSmooth(item.to)"
          >
            <span>{{ item.label }}</span>
          </button>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      MENU: [
        { label: "Home", to: "home" },
        { label: "About", to: "about" },
        { label: "Works", to: "projet" },
      ],
      activeSection: null,
    };
  },
  mounted() {
    // Ajoute un gestionnaire d'événements de défilement lors du montage du composant
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },

  beforeUnmount() {
    // Nettoie le gestionnaire d'événements de défilement avant que le composant soit détruit
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    scrollSmooth(to) {
      this.activeSection = to;
      this.$emit("move", to);
    },
    handleScroll() {
      for (const item of this.MENU) {
        const section = document.getElementById(item.to);
        if (section) {
          const rect = section.getBoundingClientRect();
          console.log(
            `Section: ${item.to}, Top: ${rect.top}, Bottom: ${rect.bottom}`
          );
          if (
            rect.top <= window.innerHeight / 2 &&
            rect.bottom >= window.innerHeight / 2
          ) {
            this.activeSection = item.to;
            console.log(`Active Section: ${this.activeSection}`);
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.nav-box {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  overflow: hidden;
  bottom: 5px;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.show-nav {
  opacity: 1;
  transform: translateY(0);
}

.active-link {
  color: var(--first-color) !important;
}

.nav-content {
  box-shadow: 0 0 5px var(--first-color);
}

.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}

.flex {
  display: flex;
}

.w-full {
  width: 100%;
}

.w-max {
  width: max-content;
}

.cursor-pointer {
  cursor: pointer;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.gap-8 {
  gap: 2.5rem;
}

.overflow-hidden {
  overflow: hidden;
}

.rounded-\[4rem\] {
  border-radius: 4rem;
}

.bg-white {
  background: var(--body-color);
}

.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness)
    var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale)
    var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert)
    var(--tw-backdrop-opacity) var(--tw-backdrop-saturate)
    var(--tw-backdrop-sepia);
}

li {
  list-style: none;
}

button {
  outline: none;
  background: transparent;
}

.link {
  position: relative;
  white-space: nowrap;
  color: var(--text-color);
}

.link::before,
.link::after {
  position: absolute;
  width: 100%;
  height: 1px;
  background: var(--first-color-alt);
  top: 100%;
  left: 0;
  pointer-events: none;
}

.link::before {
  content: "";
}

.link--elara::before {
  transform-origin: 50% 100%;
  transition: clip-path 0.3s, transform 0.3s cubic-bezier(0.2, 1, 0.8, 1);
  clip-path: polygon(
    0% 0%,
    0% 100%,
    0 100%,
    0 0,
    100% 0,
    100% 100%,
    0 100%,
    0 100%,
    100% 100%,
    100% 0%
  );
}

.link--elara:hover::before {
  transform: translate3d(0, 2px, 0) scale3d(1.08, 3, 1);
  clip-path: polygon(
    0% 0%,
    0% 100%,
    50% 100%,
    50% 0,
    50% 0,
    50% 100%,
    50% 100%,
    0 100%,
    100% 100%,
    100% 0%
  );
}

.link--elara span {
  display: inline-block;
  transition: transform 0.3s cubic-bezier(0.2, 1, 0.8, 1);
}

.link--elara:hover span {
  transform: translate3d(0, -2px, 0);
}
</style>
